<template>
  <div class="container py-4">
    <!-- Branch Selector + Navigation Buttons -->
    <div class="form-group row align-items-center">
      <label class="col-sm-2 col-form-label">{{ $store.state.table.namaCabang }} :</label>
      <div class="col-sm-6">
        <select class="form-control" v-model="selectedBranch">
          <option value="">--Select Branch--</option>
          <option value="all">All Branch</option>
          <option v-for="i in cabang" :key="i.cabangId" :value="i.cabangId">
            {{ i.namaCabang }}
          </option>
        </select>
      </div>
      <div class="col-sm-4 d-flex justify-content-end">
        <!-- Weekly Controls -->
        <div v-if="filterType === 'weekly'">
          <button class="btn btn-primary btn-sm mr-2" @click="goPreviousWeek">Previous Week</button>
          <button v-if="!isCurrentWeek" class="btn btn-primary btn-sm" @click="goNextWeek">Next Week</button>
        </div>
        <!-- Monthly Controls -->
        <div v-if="filterType === 'monthly'">
          <button class="btn btn-primary btn-sm mr-2" @click="goPreviousMonth">Previous Month</button>
          <button v-if="!isCurrentMonth" class="btn btn-primary btn-sm" @click="goNextMonth">Next Month</button>
        </div>
      </div>
    </div>

    <!-- Chart Section -->
    <div v-if="!loading">
      <Chart @changePeriod="filterType = $event" :filterType="filterType" :data="kpi_data" />
    </div>
    <div v-else class="skeleton skeleton-chart mb-4"></div>

    <!-- Points Section -->
    <div class="row">
      <!-- Higher Point -->
      <div class="col-md-6">
        <div class="card p-3 mb-3">
          <h5 class="mb-3">Highest Point</h5>
          <div v-if="!loading">
            <Carousel @clicked="set_reward($event)" :cards="higherPoint" button="Reward" />
          </div>
          <div v-else class="skeleton skeleton-carousel"></div>
        </div>
      </div>

      <!-- Lower Point -->
      <div class="col-md-6">
        <div class="card p-3 mb-3">
          <h5 class="mb-3">Lowest Point</h5>
          <div v-if="!loading">
            <Carousel @clicked="set_punish($event)" :cards="lowerPoint" button="Warning" buttonColor="danger" />
          </div>
          <div v-else class="skeleton skeleton-carousel"></div>
        </div>
      </div>
    </div>

    <ModalReward :dataReward="dataReward" :visible="showReward" @close="closeReward()" @alertFromChild="triggerAlert($event)" />
    <Punishment :dataPunish="dataPunish" :visible="showPunish" @close="closePunish()" @alertFromChild="triggerAlert($event)" />
  </div>
</template>

<script>
import Chart from "./chart.vue";
import Carousel from "./Carousel.vue";
import moment from "moment";
import ModalReward from "./ModalReward.vue";
import Punishment from "./Punishment.vue";

export default {
  name: "DashboardPage",
  components: { Chart, Carousel, ModalReward, Punishment },
  data() {
    return {
      cabang: [],
      selectedBranch: "",
      filterType: "weekly",
      higherPoint: [],
      lowerPoint: [],
      tanggal_awal: null,
      tanggal_akhir: null,
      showReward: false,
      showPunish: false,
      dataBottom: null,
      dataReward: null,
      dataPunish: null,
      loading: true,
    };
  },
  computed: {
    fetch_data() {
      return {
        jumlah: 1000,
        halaman: "0",
        cabangId: this.selectedBranch,
        tglAwal: this.tanggal_awal,
        tglAkhir: this.tanggal_akhir,
      };
    },
    isCurrentWeek() {
      return moment(this.tanggal_awal).isSame(moment().startOf("week"), "day") && moment(this.tanggal_akhir).isSame(moment().endOf("week"), "day");
    },
    isCurrentMonth() {
      return moment(this.tanggal_awal).isSame(moment().startOf("month"), "day") && moment(this.tanggal_akhir).isSame(moment().endOf("month"), "day");
    },
  },
  methods: {
    set_reward(data) {
      this.dataReward = data;
      this.showReward = true;
    },
    closeReward() {
      this.showReward = false;
    },
    closePunish() {
      this.showPunish = false;
    },
    set_punish(data) {
      this.dataPunish = data;
      this.showPunish = true;
    },
    async get_cabang() {
      const vm = this;
      let listCabang = await vm.$axios.post("cabang/list", vm.fetch_data);
      vm.cabang =
        listCabang.data.status == 200
          ? listCabang.data.data.map((x, idx) => ({
              ...x,
              no: (vm.currentPage - 1) * vm.perPage + idx + 1,
            }))
          : [];
    },
    async get_top() {
      let vm = this;
      vm.higherPoint = [];
      let top = await vm.$axios.post("dataKaryawan/top3", vm.fetch_data);
      vm.higherPoint = top.data.data;
    },
    async get_bottom() {
      let vm = this;
      vm.lowerPoint = [];
      let bottom = await vm.$axios.post("dataKaryawan/bottom3", vm.fetch_data);
      vm.lowerPoint = bottom.data.data;
    },
    async get_kpi() {
      let vm = this;
      vm.kpi_data = [];
      let kpi = await vm.$axios.post("dataKaryawan/chartLine", vm.fetch_data);
      vm.kpi_data = kpi.data.data;
    },
    getAvatar(avatar) {
      return avatar && avatar.trim() !== "" ? avatar : "https://picsum.photos/200";
    },
    updateDateRange() {
      if (this.filterType === "weekly") {
        this.tanggal_awal = moment().startOf("week").format("YYYY-MM-DD");
        this.tanggal_akhir = moment().endOf("week").format("YYYY-MM-DD");
      } else if (this.filterType === "monthly") {
        this.tanggal_awal = moment().startOf("month").format("YYYY-MM-DD");
        this.tanggal_akhir = moment().endOf("month").format("YYYY-MM-DD");
      }
    },
    async refreshData() {
      this.loading = true;
      await Promise.all([this.get_top(), this.get_bottom(), this.get_kpi()]);
      this.loading = false;
    },
    goPreviousWeek() {
      this.tanggal_awal = moment(this.tanggal_awal).subtract(1, "week").startOf("week").format("YYYY-MM-DD");
      this.tanggal_akhir = moment(this.tanggal_awal).endOf("week").format("YYYY-MM-DD");
      this.refreshData();
    },
    goNextWeek() {
      this.tanggal_awal = moment(this.tanggal_awal).add(1, "week").startOf("week").format("YYYY-MM-DD");
      this.tanggal_akhir = moment(this.tanggal_awal).endOf("week").format("YYYY-MM-DD");
      this.refreshData();
    },
    goPreviousMonth() {
      this.tanggal_awal = moment(this.tanggal_awal).subtract(1, "month").startOf("month").format("YYYY-MM-DD");
      this.tanggal_akhir = moment(this.tanggal_awal).endOf("month").format("YYYY-MM-DD");
      this.refreshData();
    },
    goNextMonth() {
      this.tanggal_awal = moment(this.tanggal_awal).add(1, "month").startOf("month").format("YYYY-MM-DD");
      this.tanggal_akhir = moment(this.tanggal_awal).endOf("month").format("YYYY-MM-DD");
      this.refreshData();
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      // vm.getDatas();
    },
  },
  mounted() {
    this.updateDateRange();
    this.get_cabang();
    this.refreshData();
  },
  watch: {
    filterType() {
      this.updateDateRange();
      this.refreshData();
    },
    fetch_data(newV, oldV) {
      if (newV != oldV) {
        this.refreshData();
      }
    },
    deep: true,
  },
};
</script>

<style scoped>
.card {
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
}
img {
  object-fit: cover;
}

/* Skeleton Styles */
.skeleton {
  background: #e0e0e0;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}
.skeleton-chart {
  height: 200px;
}
.skeleton-carousel {
  height: 150px;
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
</style>
